(function () {
  'use strict';

  var ROOT = document.querySelector('[data-mc-hsearch]');
  if (!ROOT || ROOT.hasAttribute('data-mc-hsearch-bound')) return;
  ROOT.setAttribute('data-mc-hsearch-bound', 'true');

  var input = ROOT.querySelector('[data-mc-hsearch-input]');
  var panel = ROOT.querySelector('[data-mc-hsearch-panel]');
  var defaultPanel = ROOT.querySelector('[data-mc-hsearch-default]');
  var clearBtn = ROOT.querySelector('[data-mc-hsearch-clear]');
  var form = ROOT.querySelector('.mc-hsearch__form');
  if (!input || !panel || !form) return;

  Array.prototype.forEach.call(
    document.querySelectorAll('.t4s-site-nav__search, .t4s-site-nav__search a'),
    function (el) {
      el.removeAttribute('data-drawer-options');
      el.removeAttribute('data-drawer-delay');
      el.removeAttribute('data-drawer-delay-');
    },
  );

  function hasDefault() {
    return defaultPanel && defaultPanel.children.length > 0;
  }

  var MIN = 2;
  var DEBOUNCE = 220;
  var timer = null;
  var lastQuery = '';
  var controller = null;
  var activeIndex = -1;

  var SUGGEST = '/search/suggest.json';
  var PARAMS =
    '&resources[type]=product' +
    '&resources[limit]=8' +
    '&resources[options][unavailable_products]=last' +
    '&resources[options][fields]=title,product_type,variants.title,vendor';

  var money = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(value) {
    if (value == null || value === '') return '';
    var n = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(n)) return '';
    try {
      return n.toLocaleString(undefined, {
        style: money ? 'currency' : 'decimal',
        currency: money || undefined,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function highlight(text, q) {
    var t = String(text || '');
    if (!q) return escapeHtml(t);
    var i = t.toLowerCase().indexOf(q.toLowerCase());
    if (i === -1) return escapeHtml(t);
    return (
      escapeHtml(t.slice(0, i)) +
      '<mark>' +
      escapeHtml(t.slice(i, i + q.length)) +
      '</mark>' +
      escapeHtml(t.slice(i + q.length))
    );
  }

  function thumb(p) {
    var img = p.featured_image && (p.featured_image.url || p.featured_image);
    if (!img && p.image) img = p.image;
    if (!img) return '<span class="mc-hsearch__thumb" aria-hidden="true"></span>';
    var url = String(img).replace(/(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i, '_400x$1$2');
    return (
      '<img class="mc-hsearch__thumb" src="' +
      escapeHtml(url) +
      '" alt="" loading="lazy" width="400" height="400">'
    );
  }

  function priceHtml(p) {
    var min = p.price_min != null ? p.price_min : p.price;
    var cmp = p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price;
    var cur = formatMoney(min);
    if (!cur) return '';
    if (cmp && parseFloat(cmp) > parseFloat(min)) {
      return '<del>' + escapeHtml(formatMoney(cmp)) + '</del><ins>' + escapeHtml(cur) + '</ins>';
    }
    return escapeHtml(cur);
  }

  var searchIcon =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg>';
  var tagIcon =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h7l9 9-7 7-9-9V4z"></path><circle cx="8" cy="8" r="1.4" fill="currentColor" stroke="none"></circle></svg>';

  function render(data, q) {
    var res = (data && data.resources && data.resources.results) || {};
    var queries = res.queries || [];
    var collections = res.collections || [];
    var products = res.products || [];
    var html = '';

    if (queries.length || collections.length) {
      html += '<div class="mc-hsearch__section">';
      queries.slice(0, 4).forEach(function (qi) {
        var text = qi.text || qi.title || '';
        html +=
          '<a class="mc-hsearch__suggestion" role="option" href="/search?q=' +
          encodeURIComponent(text) +
          '&type=product">' +
          searchIcon +
          '<span>' +
          highlight(text, q) +
          '</span></a>';
      });
      collections.slice(0, 3).forEach(function (c) {
        html +=
          '<a class="mc-hsearch__suggestion" role="option" href="' +
          escapeHtml(c.url) +
          '">' +
          tagIcon +
          '<span>' +
          highlight(c.title, q) +
          '</span></a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<div class="mc-hsearch__section mc-hsearch__section--products">';
      products.forEach(function (p) {
        html +=
          '<a class="mc-hsearch__product" role="option" href="' +
          escapeHtml(p.url) +
          '">' +
          thumb(p) +
          '<span class="mc-hsearch__pinfo">' +
          '<span class="mc-hsearch__ptitle">' +
          escapeHtml(p.title) +
          '</span>' +
          (p.vendor
            ? '<span class="mc-hsearch__pvendor">' + escapeHtml(p.vendor) + '</span>'
            : '') +
          '</span>' +
          '<span class="mc-hsearch__price">' +
          priceHtml(p) +
          '</span>' +
          '</a>';
      });
      html += '</div>';
    }

    if (!html) {
      panel.innerHTML =
        '<div class="mc-hsearch__state">No matches for <strong>' +
        escapeHtml(q) +
        '</strong></div>';
      open();
      return;
    }

    html +=
      '<a class="mc-hsearch__all" href="/search?q=' +
      encodeURIComponent(q) +
      '&type=product">See all results for “' +
      escapeHtml(q) +
      '”</a>';
    panel.innerHTML = html;
    activeIndex = -1;
    open();
  }

  function open() {
    if (defaultPanel) defaultPanel.hidden = true;
    if (panel.hidden) panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function showDefault() {
    panel.hidden = true;
    if (defaultPanel) defaultPanel.hidden = true;
    activeIndex = -1;
  }
  function close() {
    panel.hidden = true;
    if (defaultPanel) defaultPanel.hidden = true;
    ROOT.classList.remove('is--desktop-open');
    document.documentElement.classList.remove('mc-hsearch-open');
    input.setAttribute('aria-expanded', 'false');

    input.value = '';
    lastQuery = '';
    if (clearBtn) clearBtn.hidden = true;
    activeIndex = -1;
  }

  function activePanel() {
    if (defaultPanel && !defaultPanel.hidden) return defaultPanel;
    return panel;
  }
  function options() {
    return Array.prototype.slice.call(
      activePanel().querySelectorAll('[role="option"], .mc-hsearch__chip, .mc-hsearch__all'),
    );
  }
  function setActive(i) {
    var opts = options();
    if (!opts.length) return;
    activeIndex = (i + opts.length) % opts.length;
    opts.forEach(function (o, idx) {
      o.classList.toggle('is--active', idx === activeIndex);
    });
    var el = opts[activeIndex];
    if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  function fetchResults(q) {
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    panel.innerHTML = '<div class="mc-hsearch__state">Searching…</div>';
    open();
    fetch(SUGGEST + '?q=' + encodeURIComponent(q) + PARAMS, {
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined,
    })
      .then(function (r) {
        return r.ok ? r.json() : Promise.reject(r.status);
      })
      .then(function (data) {
        if (input.value.trim() === q) render(data, q);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        panel.innerHTML = '<div class="mc-hsearch__state">Search is unavailable right now.</div>';
        open();
      });
  }

  function onInput() {
    var q = input.value.trim();
    clearBtn.hidden = q.length === 0;
    if (q.length < MIN) {
      lastQuery = '';
      showDefault();
      return;
    }
    if (q === lastQuery) {
      open();
      return;
    }
    lastQuery = q;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      fetchResults(q);
    }, DEBOUNCE);
  }

  input.addEventListener('input', onInput);
  input.addEventListener('focus', function () {
    var q = input.value.trim();
    if (q.length >= MIN && panel.innerHTML) open();
    else showDefault();
  });

  function collapseIfEmpty() {
    if (input.value.trim() !== '') return;
    if (ROOT.classList.contains('is--desktop-open')) close();
  }

  input.addEventListener('blur', function () {
    setTimeout(collapseIfEmpty, 120);
  });

  if (window.visualViewport) {
    var mcLastVVH = window.visualViewport.height;
    window.visualViewport.addEventListener('resize', function () {
      var h = window.visualViewport.height;
      var keyboardClosed = h - mcLastVVH > 90;
      mcLastVVH = h;
      if (keyboardClosed) setTimeout(collapseIfEmpty, 60);
    });
  }

  input.addEventListener('keydown', function (e) {
    if (panel.hidden) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(activeIndex + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(activeIndex - 1);
    } else if (e.key === 'Enter') {
      var opts = options();
      if (activeIndex > -1 && opts[activeIndex]) {
        e.preventDefault();
        opts[activeIndex].click();
      }
    } else if (e.key === 'Escape') {
      close();
    }
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    lastQuery = '';
    input.focus();
    showDefault();
  });

  form.addEventListener('submit', function () {});

  document.addEventListener('click', function (e) {
    if (!ROOT.contains(e.target)) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && (!panel.hidden || ROOT.classList.contains('is--desktop-open')))
      close();
  });

  function isDesktop() {
    return window.matchMedia
      ? window.matchMedia('(min-width: 1000px)').matches
      : window.innerWidth >= 1000;
  }

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest(
        '.t4s-site-nav__search, .t4s-site-nav__icon.t4s-site-nav__search, [data-mc-hsearch-open]',
      );
      if (!trigger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (ROOT.classList.contains('is--desktop-open')) {
        close();
        return;
      }
      ROOT.classList.add('is--desktop-open');
      document.documentElement.classList.add('mc-hsearch-open');
      input.setAttribute('aria-expanded', 'true');

      void ROOT.offsetHeight;
      input.focus();
      if (input.value.trim().length >= MIN && panel.innerHTML) open();
      else showDefault();
    },
    true,
  );
})();
